import { Alert, AlertTitle, Typography } from '@mui/material';

import { useQuery } from '@redwoodjs/web';

import { GET_SERVICE_PROMOTION_STATUS } from 'src/graphql/queries/merchantServices.query';
import { formatDate } from 'src/utils/utils';

type ServiceTrialStatusProps = {
    serviceId: number;
};

const ServicePromoStatus = ({ serviceId }: ServiceTrialStatusProps) => {
    const { data, loading } = useQuery(GET_SERVICE_PROMOTION_STATUS, {
        skip: !serviceId,
        variables: { serviceId },
    });

    if (loading) {
        return null;
    }

    const { servicePromotionStatus } = data ?? {};

    if (!servicePromotionStatus?.onPromo) {
        return null;
    }

    return (
        <Alert
            severity="success"
            icon={false}
            variant={'filled'}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <AlertTitle variant={'h4'}>This service is currently in a Promo Period</AlertTitle>
            <Typography variant={'body1'}>
                The Promo {servicePromotionStatus?.promoType} for this service is due to end{' '}
                {formatDate({ date: servicePromotionStatus?.promoExpiryDate })}
            </Typography>
        </Alert>
    );
};

export default ServicePromoStatus;
